import React from 'react';

// Base Skeleton component with shimmer animation
export const Skeleton = ({ className = '', ...props }) => {
  return (
    <div
      className={`animate-shimmer ${className}`}
      style={{
        background: 'linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%)',
        backgroundSize: '1000px 100%'
      }}
      {...props}
    />
  );
};

// Skeleton for circular elements (avatars, thumbnails)
export const SkeletonCircle = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };

  return (
    <Skeleton
      className={`${sizeClasses[size]} rounded-full ${className}`}
    />
  );
};

// Skeleton for rectangular elements (images, thumbnails)
export const SkeletonRect = ({ width, height, className = '', rounded = 'md' }) => {
  const roundedClasses = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    xl: 'rounded-xl',
    full: 'rounded-full'
  };

  return (
    <Skeleton
      className={`${width} ${height} ${roundedClasses[rounded]} ${className}`}
    />
  );
};

// Skeleton for text lines
export const SkeletonText = ({
  lines = 1,
  widths = ['w-full'],
  height = 'h-4',
  className = ''
}) => {
  // If only one width is provided but multiple lines needed, use that width for all lines
  const lineWidths = lines > widths.length
    ? Array(lines).fill(widths[0] || 'w-full')
    : widths.slice(0, lines);

  if (lines === 1) {
    return <Skeleton className={`${height} ${lineWidths[0]} rounded ${className}`} />;
  }

  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton
          key={index}
          className={`${height} ${lineWidths[index]} rounded`}
        />
      ))}
    </div>
  );
};

// Skeleton for pill-shaped elements (tags, badges)
export const SkeletonPill = ({ width = 'w-16', height = 'h-6', className = '' }) => {
  return (
    <Skeleton
      className={`${width} ${height} rounded-full ${className}`}
    />
  );
};

// Skeleton for button elements
export const SkeletonButton = ({
  width = 'w-20',
  height = 'h-10',
  rounded = 'md',
  className = ''
}) => {
  const roundedClasses = {
    none: 'rounded-none',
    sm: 'rounded-sm',
    md: 'rounded-md',
    lg: 'rounded-lg',
    full: 'rounded-full'
  };

  return (
    <Skeleton
      className={`${width} ${height} ${roundedClasses[rounded]} ${className}`}
    />
  );
};

export default Skeleton;
